import {
  useSearchCandidatesQuery,
  useOnUpdateCandidateSubscription,
  useOnCreateCandidateSubscription
} from 'generated-graphql/hooks/apollo-hooks';
import { extractQueryListItems } from 'core/utils/apollo/extractListItems';
import { updateApolloListById } from 'core/utils/apollo/updateApolloListById';
import {
  SearchableCandidateFilterInput,
  SearchableCandidateSortInput
} from 'generated-graphql/types';

type Props = {
  filter: SearchableCandidateFilterInput;
  limit?: number;
  from?: number;
  sort?: SearchableCandidateSortInput[];
};

export const useSearchCandidatesWithSubscription = ({
  filter,
  limit,
  from,
  sort
}: Props) => {
  const { data, loading, updateQuery } = useSearchCandidatesQuery({
    variables: {
      filter,
      limit,
      from,
      sort
    }
  });

  const { error: updateError } = useOnUpdateCandidateSubscription({
    onData: ({ data: { data } }) => {
      const candidateUpdated = data?.onUpdateCandidate;

      if (!candidateUpdated) return;

      updateQuery((prevData) =>
        updateApolloListById({
          prevData,
          updatedItem: candidateUpdated,
          idKey: 'id'
        })
      );
    }
  });

  const { error: createError } = useOnCreateCandidateSubscription({
    onData: ({ data: { data } }) => {
      const candidateCreated = data?.onCreateCandidate;

      if (!candidateCreated) return;

      updateQuery((prevData) =>
        updateApolloListById({
          prevData,
          updatedItem: candidateCreated,
          idKey: 'id'
        })
      );
    }
  });

  const candidates = extractQueryListItems(data);
  const total = data?.searchCandidates?.total ?? 0;

  return {
    candidates,
    total,
    loading,
    subscriptionError: createError || updateError
  };
};
